import 'babel-polyfill'
import "es6-shim";
import "es6-promise/auto";
import "es6-map/implement";
import "es6-object-assign/auto"

import moment from "moment";
import sanitizeHTML from 'sanitize-html'

import momentDurationFormatSetup from 'moment-duration-format'

momentDurationFormatSetup(moment);

import frConfig from "moment/locale/fr";
import frCATime from "moment/locale/fr-ca";
import enGBTime from "moment/locale/en-gb";

import config from "./config";
import VueI18N from "vue-i18n";
import messages from "./i18n/index";

import Vue from 'vue';

import App from "./App";
import $ from "jquery";

import VueAlert from './plugins/alert'
import toastr from './plugins/toastr'
import IdleVue from 'idle-vue';

import BootLoader from './components/BootLoader/BootLoader.vue'

import TitleManager from "./helpers/TitleManager";
import LessonInlineGrid from "./components/Dashboard/LessonInlineGrid/LessonInlineGrid.vue";
import BloodGlucoseInput from "./components/Tracking/Input/BloodGlucose/BloodGlucose.vue";
import WeightInput from "./components/Tracking/Input/Weight/Weight.vue";
import BloodPressureInput from "./components/Tracking/Input/BloodPressure/BloodPressure.vue";
import SleepInput from "./components/Tracking/Input/Sleep/Sleep.vue";
import InsulinInput from "./components/Tracking/Input/Insulin/Insulin.vue";
import KetonesInput from "./components/Tracking/Input/Ketones/Ketones.vue";
import CholesterolInput from "./components/Tracking/Input/Cholesterol/Cholesterol.vue";
import NutritionInput from "./components/Tracking/Input/Nutrition/Nutrition.vue"
import MedicationInput from "./components/Tracking/Input/Medication/Medication.vue"
import ActivityInput from "./components/Tracking/Input/Activity/Activity.vue"
import MoodInput from "./components/Tracking/Input/Mood/Mood.vue"


import BgLineGraph from "./components/Tracking/Graphs/BloodGlucose/LineGraph.vue"
import WeightLineGraph from "./components/Tracking/Graphs/Weight/LineGraph.vue"
import CholesterolLineGraph from "./components/Tracking/Graphs/Cholesterol/LineGraph.vue"
import BloodPressureLineGraph from "./components/Tracking/Graphs/BloodPressure/LineGraph.vue"
import InsulinLineGraph from "./components/Tracking/Graphs/Insulin/LineGraph.vue"
import KetonesLineGraph from "./components/Tracking/Graphs/Ketones/LineGraph.vue"
import MedicationLineGraph from "./components/Tracking/Graphs/Medication/LineGraph.vue"
import MoodLineGraph from "./components/Tracking/Graphs/Mood/LineGraph.vue"
import SleepLineGraph from "./components/Tracking/Graphs/Sleep/LineGraph.vue"

import ProfileHeader from "./components/Profile/ProfileHeader/ProfileHeader.vue";
import ProfileAvatar from "./components/Profile/ProfileAvatar/ProfileAvatar.vue";
import LessonQuestionsPanel from "./components/Lesson/QuestionsPanel/QuestionsPanel.vue";
import LessonDownloadsPanel from "./components/Lesson/DownloadsPanel/DownloadsPanel.vue";
import LessonQuizPanel from "./components/Lesson/QuizPanel/QuizPanel.vue";
import LessonRatingPanel from "./components/Lesson/RatingPanel/RatingPanel.vue";
import AudioPlayer from "./components/AudioPlayer/AudioPlayer.vue"
import IframeVideoPlayer from "./components/IframeVideoPlayer/IframeVideoPlayer.vue"

import UserAvatar from "./components/UserAvatar/UserAvatar.vue";
import NotificationsPanel from "./components/Notifications/Notifications.vue";
import CreateQuestion from "./components/Questions/CreateQuestion/CreateQuestion.vue";
import TopContributors from "./components/Questions/TopContributors/TopContributors.vue";
import FrequentlyAsked from "./components/Questions/FrequentlyAsked/FrequentlyAsked.vue";
//Food diary
import FoodPie from "./components/FoodDiary/Graphs/Pie/pie";
import FoodPieEmpty from './components/FoodDiary/Graphs/PieEmpty/empty'
import FoodMealList from "./components/FoodDiary/MealList/MealList.vue";
// Lifestyle
import LifeCategoryList from "./components/LifeStyle/LifeCategoryList/LifeCategoryList.vue";

import UpdateHeight from "./components/Settings/Height/Height.vue";
import UploadAvatar from "./components/UploadAvatar/UploadAvatar.vue";
import UserBadge from "./components/UserBadge/UserBadge.vue"

import DatePicker from "./components/DateTimePicker/DateTimePicker.vue"
import Report from "./components/Reporting/Report.vue"
import ListReports from "./components/Reporting/ListReports.vue"
import QuestionsSearch from "./components/Questions/SearchQuestions/SearchQuestions.vue"
import ImageUploader from './components/ImageUploader/ImageUploader'

import VueMaterial from "vue-material";
import VueMarkdown from 'vue-markdown';

import SocialSharing from "vue-social-sharing";
import VeeValidate, {Validator} from "vee-validate";
import router from "./router";
import MuseUI from "muse-ui";

import axios from "axios";
import VueBase64FileUpload from "vue-base64-file-upload";
import CountTo from "vue-count-to";
import VueAnalytics from "vue-analytics";
import store from "./store";
import VTooltip from 'v-tooltip'
import EventBus from './helpers/EventBus'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle, faChevronDown, faThumbsUp, faPencilAlt, faTrash, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueGtag from "vue-gtag";

library.add(faInfoCircle, faChevronDown, faThumbsUp, faPencilAlt, faTrash, faExclamationTriangle)
Vue.component('font-awesome-icon', FontAwesomeIcon)



Vue.use(VueAnalytics, {
  id: config.GoogleCode
});

Vue.use(VueGtag, {
  config: { id: config.GoogleCode }
}, router);

Vue.use(VTooltip);
Vue.use(MuseUI);


Validator.localize(config.validationDictionary);

const customValidationDictionary = {
  en: {
    messages: {
      // strong_password_regex: field => `${field} must have 10 characters, 1 uppercase character, 1 lowercase character and 1 special character`
      strong_password_regex: field => ``
    }
  },
  fr: {
    messages: {
      strong_password_regex: field => `${field} doit contenir 10 caractères, 1 caractère majuscule, 1 caractère minuscule et 1 caractère spécial`
    }
  }
}


Validator.extend('strong_password_regex', {
  getMessage: () => {
    return 'The Password field must contain 1 upper case character, 1 lower case character and at least 1 special character'
  },
  validate: value => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\\W])(?=.{8,})");
    return strongRegex.test(value);
  }
});

Validator.extend('display_name_regex', {
  getMessage: () => {
    return 'The username field may only include upper case characters, lower case characters, numbers and one underscore or dash. Your username cannot start with an underscore or dash.'
  },
  validate: value => {
    var strongRegex = new RegExp("^([a-zA-Z0-9][-_]{0,1})*$");
    const pass = strongRegex.test(value);
    if (!pass) {
      return pass;
    }
    return (value.match(/-/g) === null || value.match(/-/g).length < 2) && (value.match(/_/g) === null || value.match(/_/g).length < 2)

  }
});

Validator.localize(customValidationDictionary);

Vue.use(VeeValidate, {
  locale: config.language,
  dictionary: {
    en: config.validationDictionary.EnglishMessages,
    fr: config.validationDictionary.FrenchMessages
  }
});


moment.locale(config.locale, enGBTime);


Vue.use(VueMaterial);
Vue.use(SocialSharing);
Vue.use(VueAlert);
Vue.use(toastr);

Vue.directive('date-picker', DatePicker);

Vue.component('vue-markdown', VueMarkdown);

//Core components
Vue.component('boot-loader', BootLoader);
Vue.component('user-avatar', UserAvatar);
Vue.component('update-height', UpdateHeight);
Vue.component('upload-avatar', UploadAvatar);
Vue.component('vue-base64-file-upload', VueBase64FileUpload);
Vue.component('count-to', CountTo);

//Tracking cards
Vue.component('blood-glucose-input', BloodGlucoseInput);
Vue.component('weight-input', WeightInput);
Vue.component('blood-pressure-input', BloodPressureInput);
Vue.component('sleep-input', SleepInput);
Vue.component('insulin-input', InsulinInput);
Vue.component('ketones-input', KetonesInput);
Vue.component('cholesterol-input', CholesterolInput);
Vue.component('nutrition-input', NutritionInput);
Vue.component('medication-input', MedicationInput);
Vue.component('activity-input', ActivityInput)
Vue.component('mood-input', MoodInput)


//Line graphs
Vue.component('bg-line-graph', BgLineGraph);
Vue.component('weight-line-graph', WeightLineGraph);
Vue.component('cholesterol-line-graph', CholesterolLineGraph);
Vue.component('bp-line-graph', BloodPressureLineGraph);
Vue.component('insulin-line-graph', InsulinLineGraph);
Vue.component('ketones-line-graph', KetonesLineGraph);
Vue.component('medication-line-graph', MedicationLineGraph);
Vue.component('mood-line-graph', MoodLineGraph);
Vue.component('sleep-line-graph', SleepLineGraph);

Vue.component('image-uploader', ImageUploader);

//Profile
Vue.component('profile-header', ProfileHeader);
Vue.component('profile-avatar', ProfileAvatar);


//Lesson
Vue.component('lesson-inline-grid', LessonInlineGrid);
Vue.component('lesson-questions-panel', LessonQuestionsPanel);
Vue.component('lesson-downloads-panel', LessonDownloadsPanel);
Vue.component('lesson-quiz-panel', LessonQuizPanel);
Vue.component('lesson-rating-panel', LessonRatingPanel);
Vue.component('audio-player', AudioPlayer);
Vue.component('iframe-video-player', IframeVideoPlayer);


//Question aio-components
Vue.component('create-question', CreateQuestion);
Vue.component('top-contributors', TopContributors);
Vue.component('frequently-asked', FrequentlyAsked);
Vue.component('questions-search', QuestionsSearch);

//FoodDiary aio-components
Vue.component('food-pie-empty', FoodPieEmpty);
Vue.component('food-pie', FoodPie);
Vue.component('food-meal-list', FoodMealList);

//Notifications
Vue.component('notifications-panel', NotificationsPanel);

//Life
Vue.component('life-category-list', LifeCategoryList);

Vue.component('report', Report);
Vue.component('list-reports', ListReports);
Vue.component('user-badge', UserBadge);


let host = window.location.hostname;
if (host === 'www.lowcarbprogram.com') {
  Vue.config.productionTip = false;
  Vue.config.devtools = false;
  Vue.config.silent = true;
} else {
  Vue.config.productionTip = true;
  Vue.config.devtools = true;
  Vue.config.silent = true;
}


Vue.material.registerTheme('default', {
  primary: 'light-blue',
  accent: 'grey',
  warn: 'grey',
  background: 'white'
});

//Set i18n
Vue.use(VueI18N);

let i18n = new VueI18N({
  locale: config.language,
  messages,
});

store.commit('setI18n', i18n);


let supportedLocales = [
  {
    name: "en_gb",
    time: 'en'
  },
  {
    name: "fr_ca",
    time: 'fr'
  },
  {
    name: "en_ca",
    time: "en"
  }
];


let locale = config.locale.toLowerCase();
let localeFormat = locale.replace('-', '_');
let isSupportedLocale = supportedLocales.filter(function (item) {
  return item.name === localeFormat;
});

if (isSupportedLocale.length === 1) {

  let localeName = isSupportedLocale[0].name;

  if (localeName === "fr") {
    moment.locale("fr");
  }

  if (localeName === "fr_ca") {
    moment.locale("fr");
  }

  if (localeName === 'en_ca') {
    moment.locale("en");
  }

  if (localeName === 'en_gb') {
    moment.locale("en");
  }
  store.commit('setLang', isSupportedLocale[0].name);
} else {
  store.commit('setLang', 'en_gb');
  moment.locale(isSupportedLocale[0].time, enGBTime);

}

axios.defaults.headers.common["Cache-Control"] = "no-cache";
axios.defaults.headers.common["Expires"] = "-1";
axios.defaults.headers.common["Pragma"] = "no-cache";

const tokenObject = JSON.parse(window.localStorage.getItem('token'));
if (_.has(tokenObject, 'refreshToken')) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + tokenObject.accessToken
}

import UserApi from './api/User'
import AuthenticationManager from './helpers/AuthenticationManager'

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const originalRequest = error.config;
  if (router.currentRoute.name === 'PasswordReset') {
    return;
  }

  if(error.response === undefined) {
    return Promise.reject(error);
  }

  if (error.response.status === 401 && originalRequest.url.indexOf('token/refresh') !== -1) {
    router.push('/login');
    return Promise.reject(error);
  }

  // Non-API (third-party) requests are not retried — retrying unconditionally
  // here caused a tight infinite loop whenever an external call errored.
  if(originalRequest.url.indexOf(config.apiUrl) === -1) {
    return Promise.reject(error);
  }

  if (error.response.status === 401 && !originalRequest._retry && originalRequest.url.indexOf('login/v2') === -1) { // If it is a login route, dont do a retry to avoid the bug discovered
    originalRequest._retry = true;
    const token = AuthenticationManager.getToken();
    return AuthenticationManager.refreshAccessToken(token)
      .then(() => {
        const newToken = AuthenticationManager.getToken();

        if (_.has(newToken, 'accessToken')) {
          error.config.headers['Authorization'] = 'Bearer ' + newToken.accessToken;
        }

        return axios(originalRequest);
      });
  }
  return Promise.reject(error);
});

router.afterEach((to, from, next) => {
  document.title = i18n.t(to.meta.i18n) + ' - ' + config.Application;
  to.meta.title = i18n.t(to.meta.i18n);
  TitleManager.setTitle('');

});

import DiscussionApi from './api/Discussion'
import Axios from "axios";
import timeZoneDetector from "jstimezonedetect";

router.beforeEach((to, from, next) => {
  $('.main-content').attr('style', '') && $(window).unbind('resize') && $('#' + to.meta.id).unbind('scroll');
  EventBus.$emit('App::dockerResizerStart');

  if (DiscussionApi.CancelRequests !== null) {
    DiscussionApi.CancelRequests();
  }

  if (to.meta.requireAuth) {
    if (AuthenticationManager.hasToken()) {
      const doExpiryCheck = (next) => {
        let parsedJwt = AuthenticationManager.parseJwt();
        let {exp} = parsedJwt;
        let expiry = moment.unix(exp);

        if(process.env.NODE_ENV === 'development') {
          console.info('TokenWillRefreshInSeconds', expiry.diff(moment(), 'seconds'));
        }

        if (expiry.diff(moment(), 'seconds') > 0) {
          next();
        } else {
          doExpiryCheck(next)
        }
      }

      setToken().then(() => {
        doExpiryCheck(next)
      }).catch((error) => {
        next({path: '/login', query: {redirect: to.fullPath}})
      });
    } else {
      next({path: '/login', query: {redirect: to.fullPath}})
    }
  } else {
    next()
  }
});

const setToken = async () => {
  const tokenObject = AuthenticationManager.getToken();
  let parsedJwt = AuthenticationManager.parseJwt();
  let {exp} = parsedJwt;
  let expiry = moment.unix(exp);
  if (expiry.diff(moment(), 'seconds') <= 0) {
    await AuthenticationManager.refreshAccessToken(tokenObject);
  }
  else {
    await AuthenticationManager.setToken(tokenObject);
  }
};

const eventBus = new Vue();

Vue.prototype.$EventBus = eventBus;
Vue.prototype.$sanitize = sanitizeHTML;

new Vue({
  el: '#app',
  i18n,
  store,
  router,
  template: '<App/>',
  components: {App}
});




// WEBPACK FOOTER //
// ./src/main.js